import React from "react";
import { getTrackGradient } from "../utils/trackHelpers";
import { EditModeControls } from "./EditModeControls";
import { SessionPills } from "./SessionPills";

interface TrackCardProps {
  trackKey: string;
  trackType: string;
  sessions: any[];
  isEditMode: boolean;
  editingTrackKey: string | null;
  editSessionTime: string;
  editPlayerCount: number;
  isSaving?: boolean;
  selectedSessionId: string | null;
  cartData: any[];
  productRenderedLocation: string;
  defaultQuantity?: number;
  getSessionQuantity?: (variantId: string, defaultQuantity?: number) => number;
  seatsTitle?: string;
  onSessionChange: (sessionId: string) => void;
  onIncrement: () => void;
  onDecrement: () => void;
  onSaveChanges: () => void;
  onCancelEdit: () => void;
  onSessionClick: (sessionId: string, trackKey: string) => void;
  onRemoveClick: (sessionId: string, variantTitle: string, productTitle: string, trackKey: string, sessions: any[]) => void;
  onEditDate?: (date: string) => void;
  /** Rendered on the right of the first date / section header (e.g. mobile minimise). */
  headerTrailingContent?: React.ReactNode;
}

export const TrackCard: React.FC<TrackCardProps> = ({
  trackKey,
  sessions,
  isEditMode,
  editingTrackKey,
  editSessionTime,
  editPlayerCount,
  isSaving = false,
  cartData,
  productRenderedLocation,
  defaultQuantity = 1,
  getSessionQuantity,
  seatsTitle,
  onSessionChange,
  onIncrement,
  onDecrement,
  onSaveChanges,
  onCancelEdit,
  onSessionClick,
  onRemoveClick,
  onEditDate,
  headerTrailingContent,
}) => {
  const containerGradient = getTrackGradient(trackKey);

  return (
    <div className="tw-w-full">

      {/* Edit mode uses gradient container, otherwise SessionPills handles its own containers */}
      {isEditMode && editingTrackKey === trackKey ? (
        <div className="tw-rounded-[8px] tw-p-[2px] tw-w-full" style={{ background: containerGradient }}>
          <div className="tw-bg-[#393B41] tw-rounded-[6px] tw-w-full tw-p-[4px]">
            <EditModeControls
              trackKey={trackKey}
              sessions={sessions}
              editSessionTime={editSessionTime}
              editPlayerCount={editPlayerCount}
              isSaving={isSaving}
              seatsTitle={seatsTitle}
              onSessionChange={onSessionChange}
              onIncrement={onIncrement}
              onDecrement={onDecrement}
              onSave={onSaveChanges}
              onCancel={onCancelEdit}
            />
          </div>
        </div>
      ) : (
        <SessionPills
          trackKey={trackKey}
          sessions={sessions}
          cartData={cartData}
          productRenderedLocation={productRenderedLocation}
          defaultQuantity={defaultQuantity}
          getSessionQuantity={getSessionQuantity}
          onEditDate={onEditDate}
          onRemoveSession={onRemoveClick}
          onSessionClick={onSessionClick}
          headerTrailingContent={headerTrailingContent}
        />
      )}
    </div>
  );
};
